import React from 'react';

import cn from 'classnames';
import { Trans, useTranslation } from 'react-i18next';

import { CustomReactTooltip } from '@shared/ui';

import cls from './RoundingOption.module.css';

interface RoundingOptionProps {
    classes?: string;
    onEditRoundingOption?: (roundingValue: string) => void;
}

export const RoundingOption = ({ classes, onEditRoundingOption }: RoundingOptionProps) => {
    const { t } = useTranslation();
    return (
        <div className={cn(cls.RoundingOption, [classes])}>
            <div
                onClick={() => onEditRoundingOption('rounding-no')}
                className={cls.RoundingOptionItem}
            >
                {t('roundingTypeValue.roundingNo')}
            </div>
            <div
                onClick={() => onEditRoundingOption('rounding-up')}
                className={cls.RoundingOptionItem}
            >
                {t('roundingTypeValue.roundingUp')}
            </div>
            <div
                onClick={() => onEditRoundingOption('rounding-down')}
                className={cls.RoundingOptionItem}
            >
                {t('roundingTypeValue.roundingDown')}
            </div>
            <div
                onClick={() => onEditRoundingOption('rounding-constant')}
                className={cls.RoundingOptionItem}
            >
                {t('roundingTypeValue.roundingConstant')}
                <CustomReactTooltip
                    content={<Trans i18nKey="roundingTypeValue.roundingConstant.title.React" />}
                    tooltipId="roundingTooltipConstant"
                    place="right"
                />
                <span style={{ height: 13 }} data-tip data-for="roundingTooltipConstant">
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_1890_1923)">
                            <path
                                d="M6.5 12.3686C5.31331 12.3686 4.15328 12.0167 3.16658 11.3574C2.17989 10.6981 1.41085 9.76106 0.956725 8.66471C0.5026 7.56835 0.38378 6.36195 0.615291 5.19807C0.846802 4.03418 1.41825 2.96508 2.25736 2.12597C3.09648 1.28685 4.16557 0.715409 5.32946 0.483898C6.49335 0.252386 7.69975 0.371206 8.7961 0.825332C9.89246 1.27946 10.8295 2.04849 11.4888 3.03519C12.1481 4.02188 12.5 5.18192 12.5 6.36861C12.4983 7.95938 11.8656 9.4845 10.7407 10.6093C9.6159 11.7342 8.09077 12.3669 6.5 12.3686ZM6.5 1.36861C5.5111 1.36861 4.5444 1.66185 3.72215 2.21126C2.89991 2.76067 2.25904 3.54156 1.8806 4.45519C1.50217 5.36882 1.40315 6.37415 1.59608 7.34406C1.789 8.31396 2.26521 9.20488 2.96447 9.90414C3.66373 10.6034 4.55465 11.0796 5.52455 11.2725C6.49445 11.4655 7.49979 11.3664 8.41342 10.988C9.32705 10.6096 10.1079 9.9687 10.6573 9.14646C11.2068 8.32421 11.5 7.35751 11.5 6.36861C11.4985 5.04297 10.9713 3.77205 10.0339 2.83468C9.09656 1.89732 7.82564 1.37006 6.5 1.36861Z"
                                fill="currentColor"
                            />
                            <path
                                d="M6.99975 7.86839H5.99975V7.49689C5.99237 7.1441 6.07954 6.79576 6.25221 6.48803C6.42489 6.18031 6.67679 5.9244 6.98175 5.74689C7.16649 5.64514 7.31432 5.48759 7.40413 5.29675C7.49393 5.10592 7.5211 4.89159 7.48175 4.68439C7.44279 4.48699 7.34587 4.30568 7.20337 4.16363C7.06088 4.02158 6.87927 3.92523 6.68175 3.88689C6.53761 3.86021 6.38937 3.86554 6.24752 3.90252C6.10567 3.93949 5.97369 4.0072 5.86091 4.10084C5.74814 4.19449 5.65733 4.31179 5.59492 4.44442C5.53251 4.57706 5.50002 4.7218 5.49975 4.86839H4.49976C4.49988 4.51564 4.5933 4.1692 4.77053 3.86421C4.94777 3.55922 5.20251 3.30654 5.50893 3.13178C5.81534 2.95702 6.16253 2.86642 6.51526 2.86916C6.868 2.87189 7.21374 2.96787 7.5174 3.14736C7.82107 3.32684 8.07187 3.58345 8.24435 3.89115C8.41683 4.19886 8.50486 4.5467 8.49952 4.89941C8.49417 5.25211 8.39564 5.59713 8.21391 5.89946C8.03218 6.2018 7.77372 6.45069 7.46475 6.62089C7.31712 6.71319 7.19642 6.84275 7.11478 6.99653C7.03315 7.15032 6.99348 7.32289 6.99975 7.49689V7.86839Z"
                                fill="currentColor"
                            />
                            <path
                                d="M6.99976 8.86861H5.99976V9.86861H6.99976V8.86861Z"
                                fill="currentColor"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_1890_1923">
                                <rect
                                    width="12"
                                    height="12"
                                    fill="white"
                                    transform="translate(0.5 0.368607)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                </span>
            </div>
        </div>
    );
};
